import { mapToTypeFromString } from '../common';
/**
 * Enum with supported locales
 */
export enum ApplicationLocale {
  en_US = 'en-US',
  en_GB = 'en-GB',
  fr_FR = 'fr-FR',
  it_IT = 'it-IT',
  pt_PT = 'pt-PT',
  es_US = 'es-US',
  ar_AE = 'ar-AE',
  zh_TW = 'zh-TW',
  zh_CN = 'zh-CN',
  de_DE = 'de-DE',
  nl_NL = 'nl-NL',
  id_ID = 'id-ID',
  ja_JP = 'ja-JP',
  ko_KR = 'ko-KR',
  ru_RU = 'ru-RU',
  th_TH = 'th-TH',
  tr_TR = 'tr-TR'
}
export namespace ApplicationLocale {
  export function fromString(input: string): ApplicationLocale {
    return mapToTypeFromString<ApplicationLocale>(ApplicationLocale, input);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/application-locale.model.ts